// Libraries
import 'jquery';
import 'popper.js';
import 'bootstrap';
import '@fancyapps/fancybox';
const moment = require('moment-timezone');
//console.log(moment.tz.guess());

import {breadcrumbProduct} from './Components/breadcrumbProduct';
import {MobileMenu} from './Components/mobileMenu';
import {MainMenu} from './Components/mainMenu';
import {Cookie} from './Components/cookie';
import {CookieHint} from './Components/cookieHint';
import {LoginCookie} from './Components/loginCookie';
import {Faq} from './Components/faq.js';
import {LoginFlyout} from './Components/loginFlyout';
import {LanguageFlyout} from './Components/languageFlyout';
import {FilterSwitch} from "./Components/filterSwitch";
import {timezoneSelector} from "./Components/timezoneSelector";
// import {PowermailValidations} from "./Components/powermailValidations";
import {registrationForm} from "./Components/registrationForm";
import {RolePopup} from "./Components/rolePopup";

import "./Components/vimeoVideoPreview";



// Global functions needed on (almost) every page
(function ($) {
    new breadcrumbProduct();
    new CookieHint(new Cookie());
    new LoginCookie(new Cookie());
    new MobileMenu();
    new MainMenu();
    new Faq();
    new LoginFlyout();
    new LanguageFlyout();
    new FilterSwitch();
    new timezoneSelector(moment);
    // new PowermailValidations();
    new registrationForm();
    new RolePopup();
})(jQuery);


